import axios from "axios";
import { HOST_API_KEY } from "../../config";

const axiosInstanceForFormData = axios.create({
  baseURL: HOST_API_KEY,
  validateStatus: (status) => {
    return status < 500;
  },
  headers: { "Content-Type": "multipart/form-data" },
});

const axiosInstance = axios.create({
  baseURL: HOST_API_KEY,
  validateStatus: (status) => {
    return status < 500;
  },
});

const axiosInstanceWithToken = axios.create({
  baseURL: HOST_API_KEY,
  validateStatus: (status) => {
    return status < 500;
  },
});

axiosInstanceWithToken.interceptors.request.use(
  (config) => {
    if (typeof window === "undefined") return config;

    const authToken = localStorage.getItem("jwtToken");

    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
axiosInstanceForFormData.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

axiosInstanceWithToken.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export { axiosInstance, axiosInstanceForFormData, axiosInstanceWithToken };
